import FullScreenLoader from "./FullScreenLoader"

export default FullScreenLoader
